import {getStudentApprovalStatusName} from "../studentConstants";

export const studentModel = ({
    dateCreatedUtc,
    dateModifiedUtc,
    dateOfBirth,
    districtId,
    districtName,
    eligibility,
    fimcStudentId,
    firstName = "",
    fullName = "",
    gradeLevel,
    gradeLevelDescription,
    hasSignedParentalConsentOutput,
    language,
    lastName = "",
    organization,
    primaryReadingMedium,
    studentApprovalStatus,
    studentId,
    userFullName,
}: Record<string, any> = {}) => ({
    dateCreatedUtc,
    dateModifiedUtc,
    dateOfBirth,
    districtId,
    districtName,
    eligibility,
    fimcStudentId,
    firstName,
    fullName,
    gradeLevel,
    gradeLevelDescription,
    hasSignedParentalConsentOutput,
    language,
    lastName,
    organization,
    primaryReadingMedium,
    studentApprovalStatus,
    studentApprovalStatusName: getStudentApprovalStatusName(studentApprovalStatus),
    studentId,
    userFullName,
});
